import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePublicPaths } from '../routes/publicPaths';
import { tProgramDescription, tProgramTitle } from '../utils/publicI18n';
import { FaHeart, FaSeedling, FaGraduationCap, FaTint, FaHandsHelping, FaHome, FaMosque } from 'react-icons/fa';

const iconComponents = {
  'adahi': <FaHeart className="text-4xl mb-4 text-brand-red" />,
  'ihyaa': <FaHeart className="text-4xl mb-4 text-brand-red" />,
  'namaa': <FaSeedling className="text-4xl mb-4 text-brand-green" />,
  'kafala': <FaGraduationCap className="text-4xl mb-4 text-brand-primary" />,
  'saqya': <FaTint className="text-4xl mb-4 text-brand-blue" />,
  'ighatha': <FaHandsHelping className="text-4xl mb-4 text-brand-orange" />,
  'imaar': <FaHome className="text-4xl mb-4 text-brand-yellow" />,
  'ramadan': <FaHandsHelping className="text-4xl mb-4 text-brand-orange" />,
  'omra': <FaMosque className="text-4xl mb-4 text-brand-primary" />,
};

const ProgramCard = ({ program }) => {
  const { t } = useTranslation();
  const paths = usePublicPaths();
  const iconKey = program.icon || program.slug;
  return (
    <Link
      to={paths.programme(program.slug)}
      className="group relative bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex flex-col h-full"
    >
      <div className="p-6 flex-1 flex flex-col items-center text-center">
        <div className="mb-4">
          {iconComponents[iconKey] || iconComponents[program.slug] || <div className="w-10 h-10 bg-gray-200 rounded-full"></div>}
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">{tProgramTitle(t, program.slug, program.title)}</h3>
        <p className="text-gray-600">{tProgramDescription(t, program.slug, program.description)}</p>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-brand-divider opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    </Link>
  );
};

export default ProgramCard;
